module.exports = __webpack_public_path__ + "files/f591dda7a44c0e43ac1d673df792ace2.png";